module.exports = __webpack_public_path__ + "static/media/1.fa9ffe61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16464/1.jpg
// module id = 562
// module chunks = 0